@let disable = disabled();
<a
  type="button"
  [ngClass]="{'!tw-cursor-not-allowed': disable}"
  (click)="!disable? action.emit(): null"
  class="tw-text-2xl"
>
  @if (isSelected()) {
    <sb-icon [icon]="'boxCheckedFilled'" class="tw-text-sbBlue-500" [highlightClass]="'tw-text-white'"></sb-icon>
  } @else {
    <sb-icon [icon]="'boxBackground'" class="tw-text-white dark:tw-text-sbGrayBlue-950"
             [highlightClass]="'tw-text-sbBlue-200 dark:tw-text-sbBlue-500'"></sb-icon>
  }
</a>
